import { useState } from "react";
import { api, formatApiErrorDetail } from "../lib/apiClient";
import { FileDown } from "lucide-react";
import { toast } from "sonner";

export default function ExportPdfButton({ projectId, section, label }) {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get(`/projects/${projectId}/export/${section}`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      const cd = res.headers["content-disposition"] || "";
      const m = cd.match(/filename="?([^"]+)"?/);
      a.download = m ? m[1] : `${section}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not generate PDF");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button data-testid={`export-pdf-${section}`} onClick={download} disabled={busy}
      className="inline-flex items-center gap-1.5 border border-[#A68A6B] text-[#A68A6B] hover:bg-[#A68A6B] hover:text-white transition-colors px-3 py-2 text-[11px] uppercase tracking-wider disabled:opacity-60">
      <FileDown size={14} strokeWidth={1.5} />
      {busy ? "Preparing…" : (label || "Download PDF")}
    </button>
  );
}
